import React from "react";
import { Button } from "@/components/ui/button";

/**
 * Reusable pagination control with prev/next + 5-page window + ellipsis.
 * Used by ToDoListPanel and MemberReportPanel.
 */
export const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;

  const maxVisiblePages = 5;
  let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
  let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
  if (endPage - startPage < maxVisiblePages - 1) {
    startPage = Math.max(1, endPage - maxVisiblePages + 1);
  }

  const pages = [];

  if (startPage > 1) {
    pages.push(
      <Button
        key={1}
        onClick={() => onPageChange(1)}
        variant="outline"
        size="sm"
        className="border-red-900/30 text-white"
      >
        1
      </Button>
    );
    if (startPage > 2) {
      pages.push(<span key="dots-start" className="text-gray-400 px-2">...</span>);
    }
  }

  for (let i = startPage; i <= endPage; i++) {
    pages.push(
      <Button
        key={i}
        onClick={() => onPageChange(i)}
        variant={currentPage === i ? "default" : "outline"}
        size="sm"
        className={currentPage === i ? "bg-red-600 text-white" : "border-red-900/30 text-white"}
      >
        {i}
      </Button>
    );
  }

  if (endPage < totalPages) {
    if (endPage < totalPages - 1) {
      pages.push(<span key="dots-end" className="text-gray-400 px-2">...</span>);
    }
    pages.push(
      <Button
        key={totalPages}
        onClick={() => onPageChange(totalPages)}
        variant="outline"
        size="sm"
        className="border-red-900/30 text-white"
      >
        {totalPages}
      </Button>
    );
  }

  return (
    <div className="flex items-center justify-center gap-2 mt-6" data-testid="pagination">
      <Button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        variant="outline"
        size="sm"
        className="border-red-900/30 text-white disabled:opacity-50"
        data-testid="pagination-prev"
      >
        Sebelumnya
      </Button>
      <div className="flex gap-1">{pages}</div>
      <Button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        variant="outline"
        size="sm"
        className="border-red-900/30 text-white disabled:opacity-50"
        data-testid="pagination-next"
      >
        Selanjutnya
      </Button>
    </div>
  );
};

export default Pagination;
